import React from "react";
export function Minus() {
  return (
    <svg
      data-id="3"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="h-4 w-4"
    >
      <path d="M5 12h14"></path>
      {/* <path d="M12 5v14"></path> */}
    </svg>
  );
}
